import { Injectable } from '@angular/core';
import { UserStatus } from '../enums/user-status';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class UserStatusProviderService {
  /* prettier-ignore */
  private entries = new Map<UserStatus, string>([
    [UserStatus.Active, 'Aktywny'],
    [UserStatus.New, 'Nowy'],
  ]);

  public label(status: UserStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<UserStatus>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
